import React from 'react';
import { FormattedMessage } from 'react-intl';
import { TextButton } from '../../../components/common';
import { Truncated } from './components';
import styles from './components/Truncated/Truncated.scss';
import { GenericNotification } from './GenericNotification';

export const pasteCutFilesNotification =
  ({ items, sourceName, targetName, onSourceClick, onTargetClick }) =>
  ({ notification }) =>
    (
      <GenericNotification
        notification={notification}
        text={
          <FormattedMessage
            id="files-manager.paste-cut-files-notification"
            values={{
              itemsCount: items.length,
              itemName: <Truncated>{items[0].name}</Truncated>,
              sourceName: (
                <TextButton
                  className={styles.truncated}
                  as="a"
                  size="small"
                  underline="always"
                  onClick={onSourceClick}
                  skin="dark"
                  dataHook="notification-link"
                >
                  {sourceName}
                </TextButton>
              ),
              targetName: (
                <TextButton
                  className={styles.truncated}
                  as="a"
                  size="small"
                  underline="always"
                  onClick={onTargetClick}
                  skin="dark"
                  dataHook="notification-link"
                >
                  {targetName}
                </TextButton>
              ),
            }}
          />
        }
      />
    );
